module.exports = __webpack_public_path__ + "img/1.d93eba2a.svg";